import { render, staticRenderFns } from "./EntityQuestion.vue?vue&type=template&id=3c6caeea&scoped=true&"
import script from "./EntityQuestion.vue?vue&type=script&lang=js&"
export * from "./EntityQuestion.vue?vue&type=script&lang=js&"
import style0 from "./EntityQuestion.vue?vue&type=style&index=0&id=3c6caeea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6caeea",
  null
  
)

export default component.exports